//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('checkList', {
//        templateUrl: 'views/components/views/checkList/checkList.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'utilityService', 'checkListService', 'economyService', 'layoutService', function ($stateParams, stateService, utilityService, checkListService, economyService, layoutService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let checkListKeyno = $stateParams.checklist_keyno;
            
//            vm.model = {
//                checkListKeyno: checkListKeyno,
//                tabletSize: layoutService.getMediaQueries().tablet,
//                bgCheckListSelection: {
//                    selected: 'HEAD',
//                    buttons: [
//                        { id: 'HEAD', label: 'checklist_head', color: 'primary', onClick: () => vm.model.bgCheckListSelection.selected = 'HEAD' },
//                        { id: 'FIELDS', label: 'checklist_fields', color: 'primary', onClick: () => vm.model.bgCheckListSelection.selected = 'FIELDS' }
//                    ]
//                },
//                searchTextButtons: [
//                    { id: 'erase', icon: 'fa fa-eraser', color: 'danger', type: 'danger', onClick: () => vm.model.edit.searchtext = '' }
//                ],
//                edit: {
//                    searchtext: ''
//                },
//                selectListAutoCreateTables: [],
//                selectListActivityTypes: [],
//                itemsListCheckItems: [],
//                lockedSave: false,
//                renumbering: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTIONS

//            async function loadEdit() {
//                vm.model.edit = (await checkListService.getEdit({ checklist_keyno: checkListKeyno }))[0];
//            }
            
//            async function loadAutoCreateTables() {
//                vm.model.selectListAutoCreateTables = await checkListService.listAutoCreateTables();
//            }

//            async function loadActivitityTypes() {
//                vm.model.selectListActivityTypes = await economyService.listActivitityTypes();
//            }

//            async function loadCheckItems() {
//                if (utilityService.validateParmsValue(vm.model.edit.checklist_keyno) !== true) return;

//                return vm.model.itemsListCheckItems = await checkListService.listCheckItems({ checklist_keyno: vm.model.edit.checklist_keyno });
//            }

//            // #endregion LOAD PROCEDURE FUNCTIONS

//            // #region BUTTON GROUP SINGLE FUNCTION

//            vm.selectBgCheckListSelection = function (value) {
//                vm.model.bgCheckListSelection.selected = value;
//            }

//            // #endregion BUTTON GROUP SINGLE FUNCTION

//            // #region MULTI DIRECTION BUTTON FUNCTIONS

//            vm.goToFunc = function (state, e) {
//                function go(parms) {
//                    if (e?.ctrlKey) {
//                        stateService.newTab(state, parms);
//                    } else {
//                        stateService.go(state, parms);
//                    }
//                }

//                switch (state) {
//                    case 'checklistitem':
//                        go({
//                            checklistitem_keyno: '0',
//                            checklist_keyno: vm.model.edit.checklist_keyno
//                        });
//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #endregion MULTI DIRECTION BUTTON FUNCTIONS

//            // #region BUTTON RENUMBER PROCEDURE FUNCTION CALL

//            vm.renumberChanges = function () {
//                vm.model.renumbering = true;

//                checkListService.renumberCheckItems({ checklist_keyno: vm.model.edit.checklist_keyno }).then(function () {
//                    vm.model.renumbering = false;
//                    loadCheckItems();
//                }, function () {
//                    vm.model.renumbering = false;
//                });
//            }

//            // #endregion BUTTON RENUMBER PROCEDURE FUNCTION CALL

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                checkListService.saveObj(vm.model.edit).then(function () {
//                    vm.model.lockedSave = false;
//                    stateService.back();
//                }, function () {
//                    vm.model.lockedSave = false;
//                });
//            }

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                await loadEdit();
//                loadAutoCreateTables();
//                loadActivitityTypes();
//                loadCheckItems();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
